export default "__VITE_ASSET__BSdqoE12__"